<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link"
                        class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-button variant="link"
                        class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom
                        title="Agregar Presupuesto"
                        aria-label="Agregar Presupuesto"
                        @click="add()">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="flex: 1 1 150px; max-width: 190px;">
              <label class="filter-label">Nº Presupuesto</label>
              <b-form-input type="number" size="sm" placeholder="Buscar por Nº" v-model="filters.number" v-on:keyup.enter.native="filterBudgets()"></b-form-input>
            </div>
            <div class="list-view-filter" style="flex: 1 1 220px; max-width: 280px;">
              <label class="filter-label">Contacto</label>
              <b-form-input type="text" size="sm" placeholder="Contacto, teléfono o empresa" v-model="filters.contact_search" v-on:keyup.enter.native="filterBudgets()"></b-form-input>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Desde</label>
              <b-form-input type="date" size="sm" v-model="filters.date_start"></b-form-input>
            </div>
            <div class="list-view-filter" style="width: 150px;">
              <label class="filter-label">Hasta</label>
              <b-form-input type="date" size="sm" v-model="filters.date_end"></b-form-input>
            </div>
            <div class="list-view-filter" style="flex: 1 1 230px; max-width: 340px;">
              <label class="filter-label">Clientes</label>
              <v-select :options="arr.filters.customers" v-model="filters.customers" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;">
              <label class="filter-label">Punto de Venta</label>
              <v-select :options="arr.filters.points_sales" v-model="filters.points_sales" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;" v-if="moduleSellersActive">
              <label class="filter-label">Vendedores</label>
              <v-select :options="arr.filters.sellers" v-model="filters.sellers" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;">
              <label class="filter-label">Estado</label>
              <v-select :options="arr.filters.status" v-model="filters.status" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;" v-if="moduleSalesActive">
              <label class="filter-label">Facturado</label>
              <v-select :options="arr.filters.invoiced" v-model="filters.invoiced" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 260px;" v-if="moduleServiceActive">
              <label class="filter-label">Recurrente Mensual</label>
              <v-select :options="arr.filters.recurrent" v-model="filters.recurrent" placeholder="Todos" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <b-button variant="outline-dark" size="sm" @click="filterBudgets()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
              <AppIcon name="filter" />
            </b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col lg="12">
          <b-card>
            <b-row v-if="configuracion.allowMultipleBudgets">
              <b-col sm="12" v-if="appliedCustomers && appliedCustomers.length === 1" class="mb-2">
                <b-form-checkbox
                  :checked="allEligibleSelected"
                  @change="toggleSelectAll()"
                  switch
                >
                  {{ allEligibleSelected ? 'Borrar selección' : 'Seleccionar todos' }}
                </b-form-checkbox>
              </b-col>
              <b-col sm="12" v-if="canInvoiceSelected" class="mb-2">
                <b-button
                  @click="generateInvoiceMultiple()"
                  type="button"
                  variant="dark"
                  size="sm"
                >
                  <AppIcon name="ticket" class="mr-1" /> Facturar Seleccionados ({{selectedBudgets.length}})
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-table class="app-table"
                        ref="table"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        sticky-header="60vh"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="table.items"
                        :fields="table.fields"
                        :current-page="table.currentPage"
                        :per-page="table.perPage"
                        :tbody-tr-class="rowClass"
                        @row-clicked="onRowClicked"
                        :busy="table.isBusy"
                        v-if="table.items.length || table.isBusy">

                    <template v-slot:table-colgroup="scope">
                      <col
                        v-for="field in scope.fields"
                        :key="field.key"
                        :style="{ width: field.width }"
                      >
                    </template>

                    <template v-slot:table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Cargando...</strong>
                      </div>
                    </template>

                    <template v-slot:cell(business)="data">
                      {{data.item.point_sale.business.reference}}
                    </template>

                    <template v-slot:cell(id)="data">
                      <div v-if="data.item.type_voucher && data.item.point_sale" class="text-nowrap">
                        {{data.item.type_voucher.name}} {{data.item.point_sale.point_sale.toString().padStart(4,'0') + '-' + data.item.number.toString().padStart(8,'0')}}
                      </div>
                    </template>

                    <template v-slot:cell(date)="data">
                      {{moment(data.item.date).format('DD/MM/YYYY')}}
                    </template>

                    <template v-slot:cell(date_expiration)="data">
                      {{moment(data.item.date_expiration).format('DD/MM/YYYY')}}
                    </template>

                    <template v-slot:cell(sellers_id)="data">
                      <span v-if="data.item.sellers_id" v-b-tooltip.hover :title="'VENDEDOR: ' + data.item.seller.staff.name">
                        <b-avatar :src="data.item.seller.staff.image"
                                  v-if="data.item.seller.staff.image">
                        </b-avatar>
                        <b-avatar v-else
                                  :text="avatarFromName(data.item.seller.staff.name).text"
                                  :style="avatarFromName(data.item.seller.staff.name).style">
                        </b-avatar>
                        <span v-if="isMobileViewport" class="ml-2">{{data.item.seller.staff.name}}</span>
                      </span>
                    </template>

                    <template v-slot:cell(staff_id)="data">
                      <span v-if="data.item.staff_id" v-b-tooltip.hover :title="'STAFF: ' + data.item.staff.name">
                        <b-avatar :src="data.item.staff.image"
                                  v-if="data.item.staff.image">
                        </b-avatar>
                        <b-avatar v-else
                                  :text="avatarFromName(data.item.staff.name).text"
                                  :style="avatarFromName(data.item.staff.name).style">
                        </b-avatar>
                        <span v-if="isMobileViewport" class="ml-2">{{data.item.staff.name}}</span>
                      </span>
                    </template>

                    <template v-slot:cell(customers_id)="data">
                      <div v-if="data.item.customer">
                        <b-avatar :src="data.item.customer.image"
                                  v-if="data.item.customer.image">
                        </b-avatar>
                        <b-avatar v-else
                                  :text="avatarFromName(data.item.customer.name).text"
                                  :style="avatarFromName(data.item.customer.name).style">
                        </b-avatar>
                        &nbsp;<b v-b-tooltip.hover
                                 :title="(data.item.contact || data.item.contact_phone || data.item.contact_company) ?
                                         ((data.item.contact ? 'Contacto: ' + data.item.contact : '') +
                                          (data.item.contact_phone ? (data.item.contact ? ' | ' : '') + 'Tel: ' + data.item.contact_phone : '') +
                                          (data.item.contact_company ? (data.item.contact || data.item.contact_phone ? ' | ' : '') + 'Empresa: ' + data.item.contact_company : '')) : ''">

                                {{data.item.customer.name}}

                                <div v-if="data.item.contact || data.item.contact_phone || data.item.contact_company"
                                      class="ml-4 text-muted"
                                      style="margin-top: -5px; font-size:85%; font-weight: 100;">
                                  <AppIcon name="person-fill" font-scale="1" class="mr-1" />
                                  <span><strong>{{ data.item.contact || 'Sin contacto' }}</strong></span>
                                </div>
                              </b>

                        <AppIcon name="circle-fill" v-if="!data.item.customer.active" class="ml-2 text-danger" v-b-tooltip.hover title="Cliente INACTIVO" />
                      </div>
                    </template>

                    <template v-slot:cell(amount_total)="data">
                      <div v-if="data.item.currency" :title="data.item.currency.name" v-b-tooltip.hover>
                        <AppIcon name="arrow-repeat" v-if="data.item.recurrent" v-b-tooltip.hover title="Recurrente (Mensual)" class="mr-1" />
                        <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: data.item.currency.code}).format(data.item.amount_total)}}</b>
                      </div>
                    </template>

                    <template v-slot:cell(observations)="data">
                      <div v-if="data.item.observations">
                        <span v-if="isMobileViewport">{{data.item.observations}}</span>
                        <span v-else v-b-tooltip.hover :title="data.item.observations"><AppIcon name="chat-square-text" /></span>
                      </div>
                    </template>

                    <template v-slot:cell(observations_internal)="data">
                      <div v-if="data.item.observations_internal">
                        <span v-if="isMobileViewport">{{data.item.observations_internal}}</span>
                        <span v-else v-b-tooltip.hover :title="data.item.observations_internal"><AppIcon name="chat-square-text" class="text-info" /></span>
                      </div>
                    </template>

                    <template v-slot:cell(select_multi)="data">
                      <div
                        v-if="showGenerateInvoice(data.item) && showStatusWon(data.item) && !isInvoiceStageProcess(data.item)"
                        @click.stop="toggleBudgetSelection(data.item)"
                        style="cursor:pointer; text-align:center;"
                      >
                        <AppIcon
                          :name="isBudgetSelected(data.item) ? 'check2-square' : 'square'"
                          :class="isBudgetSelected(data.item) ? 'text-dark' : 'text-secondary'"
                          font-scale="1.3"
                        />
                      </div>
                    </template>

                    <template v-slot:cell(invoice)="data">
                      <div v-if="data.item.sale_id">
                        <span v-if="isMobileViewport">
                          <AppIcon name="ticket" class="mr-1 text-primary" />{{data.item.sale.type_voucher.name}} {{data.item.sale.point_sale.point_sale.toString().padStart(4,'0') + '-' + data.item.sale.number.toString().padStart(8,'0')}}
                        </span>
                        <span v-else v-b-tooltip.hover :title="data.item.sale.type_voucher.name + ' ' + data.item.sale.point_sale.point_sale.toString().padStart(4,'0') + '-' + data.item.sale.number.toString().padStart(8,'0')">
                          <AppIcon name="ticket" class="text-primary" />
                        </span>
                      </div>
                      <div v-else>
                        <div v-if="isInvoiceStageProcess(data.item)">
                          <span v-if="isMobileViewport" class="text-warning">
                            <AppIcon name="ticket" class="mr-1" />Parcial: {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(data.item.amount_impute)}}
                          </span>
                          <span v-else>
                            <AppIcon name="ticket" class="text-warning" :id="'invoice-related-process-' + data.item.id" />
                            <b-popover :target="'invoice-related-process-' + data.item.id" triggers="hover">
                              <template #title>Parcialmente Facturado: <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(data.item.amount_impute)}}</b></template>
                              <div v-for="(saleRel, index) in data.item.sales_stage_related" :key="saleRel.id">
                                {{moment(saleRel.sale.date).format('D/M/Y')}} | <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(saleRel.amount_impute)}}</b> <br>
                                {{saleRel.sale.type_voucher.name}} {{saleRel.sale.point_sale.point_sale.toString().padStart(4,'0')}}-{{saleRel.sale.number.toString().padStart(8,'0')}}
                                <hr v-if="index != data.item.sales_stage_related.length-1" style="margin-top:5px; margin-bottom:5px;">
                              </div>
                            </b-popover>
                          </span>
                        </div>
                        <div v-if="isInvoiceStageFinish(data.item)">
                          <span v-if="isMobileViewport" class="text-primary">
                            <AppIcon name="ticket" class="mr-1" />Facturado 100%
                          </span>
                          <span v-else>
                            <AppIcon name="ticket" class="text-primary" :id="'invoice-related-finish-' + data.item.id" />
                            <b-popover :target="'invoice-related-finish-' + data.item.id" triggers="hover">
                              <template #title>Facturado <b>100%</b></template>
                              <div v-for="(saleRel, index) in data.item.sales_stage_related" :key="saleRel.id">
                                {{moment(saleRel.sale.date).format('D/M/Y')}} | <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(saleRel.amount_impute)}}</b> <br>
                                {{saleRel.sale.type_voucher.name}} {{saleRel.sale.point_sale.point_sale.toString().padStart(4,'0')}}-{{saleRel.sale.number.toString().padStart(8,'0')}}
                                <hr v-if="index != data.item.sales_stage_related.length-1" style="margin-top:5px; margin-bottom:5px;">
                              </div>
                            </b-popover>
                          </span>
                        </div>
                      </div>
                    </template>

                    <template v-slot:cell(f_action)="data">
                      <b-dropdown right
                                  no-caret
                                  size="sm"
                                  variant="link"
                                  boundary="window"
                                  toggle-class="app-table-action-toggle"
                                  class="pull-right">
                        <template #button-content>
                          <AppIcon name="more_vert" label="Acciones" />
                        </template>

                        <b-dropdown-item @click="openSub(data.item)">
                          <AppIcon name="visibility" /> Visualizar
                        </b-dropdown-item>

                        <b-dropdown-item @click="sendPrinterBudget(data.item)">
                          <AppIcon name="print" /> Imprimir
                        </b-dropdown-item>
                        <b-dropdown-item @click="setTemplate(data.item)" v-if="showStatusOpen(data.item) && moduleServiceActive && hasTemplateAvailable(data.item)">
                          <AppIcon name="reports" /> Contenido
                        </b-dropdown-item>

                        <b-dropdown-header v-if="showGenerateInvoice(data.item) && !isInvoiceStageProcess(data.item) && !data.item.lead">
                          ESTADO
                        </b-dropdown-header>
                        <b-dropdown-item @click="openStatus(data.item)" v-if="showGenerateInvoice(data.item) && !isInvoiceStageProcess(data.item) && !data.item.lead">
                          <AppIcon name="flag" /> Cambiar Estado
                        </b-dropdown-item>

                        <b-dropdown-header v-if="showGenerateInvoice(data.item) && showStatusWon(data.item) && !configuracion.allowMultipleBudgets">
                          ERP
                        </b-dropdown-header>
                        <b-dropdown-item @click="generateInvoice(data.item)" v-if="showGenerateInvoice(data.item) && showStatusWon(data.item) && !isInvoiceStageProcess(data.item) && !configuracion.allowMultipleBudgets">
                          <AppIcon name="ticket" /> Facturar
                        </b-dropdown-item>
                        <b-dropdown-item @click="generateInvoiceStage(data.item)" v-if="showGenerateInvoice(data.item) && showStatusWon(data.item) && hasServiceDetail(data.item)">
                          <AppIcon name="tasks" /> Facturar Etapas
                        </b-dropdown-item>

                        <b-dropdown-header v-if="showGenerateInvoice(data.item) && showStatusOpen(data.item)">Acciones</b-dropdown-header>
                        <b-dropdown-item @click="edit(data.item)" v-if="showGenerateInvoice(data.item) && showStatusOpen(data.item)">
                          <AppIcon name="edit" /> Editar
                        </b-dropdown-item>
                        <b-dropdown-item @click="remove(data.item)" v-if="access.elements.deleteBudgets && showGenerateInvoice(data.item) && showStatusOpen(data.item)">
                          <AppIcon name="delete" class="text-danger" /> Eliminar
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                </b-table>
                <EmptyState v-else icon="reports" title="No se encontraron presupuestos" description="Ajustá los filtros o el rango de fechas para ampliar la búsqueda, o generá un presupuesto nuevo con el botón Agregar." />

                <div class="app-table-footer">
                  <span class="list-view-toolbar__count" v-if="table.tablePaginate">{{ table.tablePaginate.total }} registros</span>
                  <export-excel
                      class="list-view-link"
                      :data="arr.export"
                      worksheet="Listado de Pedidos"
                      name="list-budgets.xls">
                      <AppIcon name="download" class="mr-1" /> Exportar
                  </export-excel>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="configuracion.allowMultipleBudgets && selectedBudgets.length >= 1" class="mt-2">
              <b-col md="12">
                <b-alert show variant="dark" class="d-flex align-items-center justify-content-between mb-0 py-2">
                  <span><b>{{selectedBudgets.length}}</b> presupuestos seleccionados</span>
                  <b-button variant="dark" size="sm" @click="generateInvoiceMultiple()" :disabled="!canInvoiceSelected">
                    <AppIcon name="ticket" class="mr-1" /> Facturar Seleccionados
                  </b-button>
                </b-alert>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>

      <!-- DRAWER: detalle del presupuesto seleccionado -->
      <b-sidebar
          id="sidebar-budget-detail"
          v-model="detailDrawer"
          right
          shadow
          backdrop
          title="Detalle del Presupuesto"
          width="420px"
          @hidden="hideSub">
        <div class="list-view-drawer" v-if="itemSelected">
          <div class="list-view-drawer__header">
            <div class="list-view-drawer__title">
              <span class="list-view-drawer__code" v-if="itemSelected.type_voucher && itemSelected.point_sale">
                {{itemSelected.type_voucher.name}} {{itemSelected.point_sale.point_sale.toString().padStart(4,'0') + '-' + itemSelected.number.toString().padStart(8,'0')}}
              </span>
              <div v-if="itemSelected.customer">{{itemSelected.customer.name}}</div>
              <div class="list-view-drawer__meta" v-if="itemSelected.date">
                {{moment(itemSelected.date).format('DD/MM/YYYY')}}
              </div>
            </div>
            <div class="list-view-drawer__nav">
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoPrevBudget"
                        v-b-tooltip.hover
                        title="Presupuesto anterior"
                        @click="goPrevBudget()">
                <AppIcon name="chevron-up" />
              </b-button>
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoNextBudget"
                        v-b-tooltip.hover
                        title="Presupuesto siguiente"
                        @click="goNextBudget()">
                <AppIcon name="chevron-down" />
              </b-button>
            </div>
          </div>

          <div class="list-view-drawer__stats">
            <div class="list-view-drawer__stat" v-if="itemSelected.currency">
              <span class="list-view-drawer__stat-label">Total</span>
              <span class="list-view-drawer__stat-value">
                {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(itemSelected.amount_total)}}
              </span>
            </div>
            <div class="list-view-drawer__stat" :class="{ 'list-view-drawer__stat--warning': itemSelected.status=='lost' }">
              <span class="list-view-drawer__stat-label">Estado</span>
              <span class="list-view-drawer__stat-value">
                <b-badge variant="primary" v-if="itemSelected.status=='open'">ABIERTO</b-badge>
                <b-badge variant="success" v-if="itemSelected.status=='won'">GANADO</b-badge>
                <b-badge variant="danger" v-if="itemSelected.status=='lost'">PERDIDO</b-badge>
              </span>
            </div>
          </div>

          <div>
            <div class="list-view-drawer__section-title">
              <AppIcon name="list-ul" /> Detalle
            </div>

            <b-table  class="app-table app-table--compact"
                      responsive
                      stacked
                      :hover="true"
                      :small="true"
                      :fixed="false"
                      :items="tableSub.items"
                      :fields="tableSub.fields"
                      v-if="tableSub.items.length">

              <template v-slot:cell(quantity)="row">
                {{row.item.quantity}}
                <span v-if="row.item.unit_measurement">{{row.item.unit_measurement.reference}}</span>
              </template>

              <template v-slot:cell(code)="row">
                <div v-html="getDetailCode(row.item)"></div>
              </template>

              <template v-slot:cell(product)="row">
                <div class="text-truncate" v-b-tooltip.hover :title="getDetailName(row.item)" v-html="getDetailName(row.item)"></div>
              </template>

            </b-table>
            <EmptyState v-else icon="list-ul" title="Sin items cargados" />
          </div>

          <b-button v-if="tableSub.items.length"
                    block
                    size="sm"
                    variant="outline-secondary"
                    class="text-left"
                    @click="openDetail()">
            <AppIcon name="visibility" class="mr-1" /> Ver detalle completo
          </b-button>

          <!-- Mismas acciones y condiciones del kebab de la fila: en mobile
               no hay kebab (ver loadFieldTable), así que estas quedan como
               único camino; en desktop conviven con el kebab como atajo. -->
          <div class="list-view-drawer__actions">
            <b-button size="sm" variant="outline-secondary" @click="sendPrinterBudget(itemSelected)">
              <AppIcon name="print" class="mr-1" /> Imprimir
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="showStatusOpen(itemSelected) && moduleServiceActive && hasTemplateAvailable(itemSelected)" @click="setTemplate(itemSelected)">
              <AppIcon name="reports" class="mr-1" /> Contenido
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="showGenerateInvoice(itemSelected) && !isInvoiceStageProcess(itemSelected) && !itemSelected.lead" @click="openStatus(itemSelected)">
              <AppIcon name="flag" class="mr-1" /> Cambiar Estado
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="showGenerateInvoice(itemSelected) && showStatusWon(itemSelected) && !isInvoiceStageProcess(itemSelected) && !configuracion.allowMultipleBudgets" @click="generateInvoice(itemSelected)">
              <AppIcon name="ticket" class="mr-1" /> Facturar
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="showGenerateInvoice(itemSelected) && showStatusWon(itemSelected) && hasServiceDetail(itemSelected)" @click="generateInvoiceStage(itemSelected)">
              <AppIcon name="tasks" class="mr-1" /> Facturar Etapas
            </b-button>
            <b-button size="sm" variant="outline-secondary" v-if="showGenerateInvoice(itemSelected) && showStatusOpen(itemSelected)" @click="edit(itemSelected)">
              <AppIcon name="edit" class="mr-1" /> Editar
            </b-button>
          </div>
        </div>

        <template #footer>
          <div class="list-view-drawer__footer" v-if="itemSelected && access.elements.deleteBudgets && showGenerateInvoice(itemSelected) && showStatusOpen(itemSelected)">
            <b-button size="sm" variant="outline-danger" block @click="remove(itemSelected)">
              <AppIcon name="delete" class="mr-1" /> Eliminar
            </b-button>
          </div>
        </template>
      </b-sidebar>

      <b-row>
        <b-col lg="12">
          <b-card body-class="py-2">
            <div class="list-view-footer">
              <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
                <AppIcon name="back" />
                Volver
              </b-button>

              <nav v-if="table.tablePaginate">
                <b-pagination class="mb-0"
                              size="sm"
                              pills=""
                              :total-rows="table.tablePaginate.total"
                              :per-page="table.tablePaginate.per_page"
                              v-model="table.currentPage"
                              @input="filterBudgets()" />
              </nav>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.id"
              :reference="crud.print.reference"
              :registerID="crud.print.id"
              :key="crud.print.key"
              :manyFormat="true"/>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              size="xl"
              dialog-class="budgets-form-modal-dialog"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="edit" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <form-wizard  title=""
                      subtitle=""
                      nextButtonText="Siguiente"
                      backButtonText="Atrás"
                      finishButtonText="Guardar"
                      color="#2f353a"
                      shape="tab"
                      @on-complete="save"
                      class="crud-budgets-wizard"
                      ref="wizard">

          <tab-content title="General" icon="fa fa-edit" :before-change="budgetValidDetailGeneral">
            <b-row>
              <b-col md="4">
                <b-form-group label="Contacto" description="Nombre de la persona que solicitó el presupuesto">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.contact"
                                required
                                placeholder="Ingresar un nombre de contacto"
                                ref="input_contact">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Teléfono" description="Ej: 5493416908870 (13 dígitos)">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.contact_phone"
                                placeholder="Ingresar teléfono"
                                ref="input_contact_phone">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Empresa" description="Empresa del contacto">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.contact_company"
                                placeholder="Ingresar empresa"
                                ref="input_contact_company">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2" v-if="moduleServiceActive">
                <b-form-checkbox
                  v-model="crud.form.recurrent"
                  switch
                  size="sm"
                  class="pull-right mt-4">
                  <b>¿Es Recurrente?</b> <i>(Mensual)</i>
                </b-form-checkbox>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <FindObject render="search"
                            type="customers"
                            @select-object="loadCustomers($event)"
                            :valueID="crud.form.customers_id"
                            :where="conditionCustomersActive"
                            :disabled="crud.form.id>0"
                            ref="searchCustomer"
                            title="Buscador (F2)" />
              </b-col>
              <b-col md="4">
                <b-form-group label="Fecha">
                  <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Fecha Vencimiento">
                  <b-form-datepicker size="sm" v-model="crud.form.date_expiration" placeholder="Fecha Vencimiento" local="es"></b-form-datepicker>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <FindObject render="search"
                            type="erpPointsSales"
                            auto-select-single
                            display="full_identification"
                            @select-object="loadPointsSales($event)"
                            :valueID="crud.form.points_sales_id"
                            :key="crud.form.points_sales_id"
                            :disabled="crud.form.id>0"
                            :where="conditionPointsSalesActive" />
              </b-col>
              <b-col md="4">
                <FindObject render="search"
                            type="erpMethodsPayment"
                            auto-select-single
                            @select-object="loadMethodsPayment($event)"
                            :valueID="crud.form.methods_payment_id"
                            :key="crud.form.methods_payment_id" />
              </b-col>
              <b-col md="4">
                <FindObject render="search"
                            type="priceList"
                            @select-object="loadPriceList($event)"
                            :valueID="crud.form.price_list_id"
                            :key="crud.form.price_list_id"
                            :where="conditionPriceListActive"
                            :disabled="crud.form.id>0" />
              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Detalle" icon="fa fa-list" :before-change="budgetValidDetailItems">
            <b-row>
              <b-col lg="12" md="12" sm="12">
                  <Detail :customer_id="crud.form.customers_id"
                          :price_list_id="crud.form.price_list_id"
                          :disable-customer-price-list-fallback="crud.form.disable_customer_price_list_fallback"
                          @load-detail-products="setDetailItems($event, 'products')"
                          @load-detail-products-compound="setDetailItems($event, 'productsCompound')"
                          @load-detail-services="setDetailItems($event, 'services')"
                          @load-detail-concepts="setDetailItems($event, 'concepts')"
                          :detailProducts="crud.form.detailProducts"
                          :detailProductsCompound="crud.form.detailProductsCompound"
                          :detailServices="crud.form.detailServices"
                          :detailConcepts="crud.form.detailConcepts"
                          :hideConcepts="false"
                          :key="'detailBudget_'+itemDetailForceUpdate"
                          :forceUpdate="itemDetailForceUpdate"
                          :validItemDuplicatedProduct="!parameters.multipleItems"
                          :validItemDuplicatedConcept="!parameters.multipleItems"
                          :methodPayment="crud.form.methods_payment" />

                  <b-row class="mt-0 pt-1 pl-3 pr-3" align-v="end">
                    <b-col md="6" :offset-md="6" class="mb-0" v-if="showCheckNotIva">
                      <b-form-checkbox
                        v-model="crud.form.not_iva"
                        switch
                        size="sm"
                        class="pull-right">
                        <b>Precios sin IVA</b>
                      </b-form-checkbox>
                    </b-col>
                  </b-row>

                  <b-row class="pl-3 pr-3 pb-2 mt-2">
                    <b-col md="2" class="mb-2 mb-md-0">
                      <div class="crud-budgets-stat">
                        <span class="crud-budgets-stat__label">Items</span>
                        <span class="crud-budgets-stat__value">{{this.getCantItemBudget}}</span>
                      </div>
                    </b-col>
                    <b-col md="6" class="mb-2 mb-md-0 d-flex align-items-center justify-content-center">
                      <b-button variant="outline-info" size="sm" @click="showSurchargeMethodPayment()">
                        <AppIcon name="money" class="mr-1" />Otros Métodos de Pago
                      </b-button>
                    </b-col>
                    <b-col md="4" v-if="getCurrencyBudget">
                      <div class="crud-budgets-totals">
                        <div class="crud-budgets-totals__row">
                          <span class="crud-budgets-totals__label">Subtotal</span>
                          <span class="crud-budgets-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(totals.subtotal)}}</span>
                        </div>
                        <div class="crud-budgets-totals__row">
                          <span class="crud-budgets-totals__label">Descuento</span>
                          <div class="crud-budgets-totals__discount-group">
                            <div class="crud-budgets-totals__discount">
                              <app-text-input v-model="crud.form.percentage_discount"
                                              type="number"
                                              min="0"
                                              max="100"
                                              step="1"
                                              size="sm"
                                              @change="validDiscounts()"/>
                              <span class="crud-budgets-totals__discount-suffix">%</span>
                            </div>
                            <span class="crud-budgets-totals__value" :class="{'text-danger': parseFloat(totals.discount) > 0}">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(totals.discount)}}</span>
                          </div>
                        </div>
                        <div class="crud-budgets-totals__row">
                          <span class="crud-budgets-totals__label">Subtotal</span>
                          <span class="crud-budgets-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(totals.subtotal_discount)}}</span>
                        </div>
                        <div class="crud-budgets-totals__row">
                          <span class="crud-budgets-totals__label">IVA</span>
                          <span class="crud-budgets-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(totals.iva)}}</span>
                        </div>
                        <div class="crud-budgets-totals__row crud-budgets-totals__row--total">
                          <span class="crud-budgets-totals__label">Total</span>
                          <span class="crud-budgets-totals__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(totals.total)}}</span>
                        </div>
                        <div class="crud-budgets-totals__row crud-budgets-totals__row--total" v-if="crud.form.methods_payment && parseFloat(crud.form.methods_payment.surcharge) > 0">
                          <span class="crud-budgets-totals__label">{{this.crud.form.methods_payment.name}} ({{ this.crud.form.methods_payment.surcharge }}%)</span>
                          <span class="crud-budgets-totals__value text-primary">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(totals.total_surcharge)}}</span>
                        </div>
                      </div>
                    </b-col>
                  </b-row>

              </b-col>
            </b-row>
          </tab-content>

          <tab-content title="Observaciones" icon="fa fa-flag-checkered">
            <b-row>
              <b-col md="12">
                <b-form-group label="Observaciones">
                  <app-textarea
                    v-model="crud.form.observations"
                    placeholder="Ingresar las observaciones..."
                    rows="3"
                    max-rows="6"
                    lazy
                  ></app-textarea>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <hr>
              </b-col>
              <b-col md="12" v-if="moduleServiceActive">
                <b-form-group label="Título" description="Este título se utiliza en la impresión del presupuesto">
                  <b-form-input type="text"
                                size="sm"
                                v-model="crud.form.title"
                                required
                                placeholder="Ingresar un título">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Observaciones Internas" description="Estas observaciones no se muestran en la impresión">
                  <app-textarea
                    v-model="crud.form.observations_internal"
                    placeholder="Ingresar las observaciones internas..."
                    rows="3"
                    max-rows="6"
                    lazy
                  ></app-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </tab-content>

        </form-wizard>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="cancel()">Cancelar</b-button>
        </div>
      </b-modal>

      <!-- CRUD DETAILS -->
      <b-modal v-model="modal.detail.active"
              size="xl"
              dialog-class="budgets-form-modal-dialog"
              :key="modal.detail._id"
              :id="modal.detail._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="visibility" /></span>
          <h5 class="app-modal-header__title">{{this.modal.detail.title}}</h5>
        </div>

        <b-row>
          <b-col sm="12">
            <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-dark">
              <b-tab>
                <template #title><AppIcon name="description" class="mr-1" /> General</template>
                <div class="app-modal-detail-list" v-if="itemSelected">
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">ID</span>
                    <span class="app-modal-detail-list__value"><b>#{{this.itemSelected.id}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Empresa</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.point_sale.business.reference}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.type_voucher && itemSelected.point_sale">
                    <span class="app-modal-detail-list__label">Comprobante</span>
                    <span class="app-modal-detail-list__value"><b>{{this.itemSelected.type_voucher.name + ' ' + this.itemSelected.point_sale.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.number.toString().padStart(8,'0')}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.staff || itemSelected.seller">
                    <span class="app-modal-detail-list__label">Emisor</span>
                    <span class="app-modal-detail-list__value">
                      <span v-if="itemSelected.seller">{{itemSelected.seller.name}}</span>
                      <span v-else>{{itemSelected.staff.name}}</span>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Fecha</span>
                    <span class="app-modal-detail-list__value">{{moment(this.itemSelected.date).format('DD MMMM YYYY')}}</span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Fecha Vencimiento</span>
                    <span class="app-modal-detail-list__value">{{moment(this.itemSelected.date_expiration).format('DD MMMM YYYY')}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.point_sale">
                    <span class="app-modal-detail-list__label">Punto de Venta</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.point_sale.point_sale}} - {{this.itemSelected.point_sale.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.customer">
                    <span class="app-modal-detail-list__label">Cliente</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.customer.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.contact || itemSelected.contact_phone || itemSelected.contact_company">
                    <span class="app-modal-detail-list__label">Contacto</span>
                    <span class="app-modal-detail-list__value">
                      <span v-if="itemSelected.contact">{{this.itemSelected.contact}}</span>
                      <span v-if="itemSelected.contact && (itemSelected.contact_phone || itemSelected.contact_company)"> - </span>
                      <span v-if="itemSelected.contact_phone">
                        <AppIcon name="phone" class="mr-1" />
                        {{this.itemSelected.contact_phone}}
                      </span>
                      <span v-if="itemSelected.contact_phone && itemSelected.contact_company"> - </span>
                      <span v-if="itemSelected.contact_company">
                        <AppIcon name="building" class="mr-1" />
                        {{this.itemSelected.contact_company}}
                      </span>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.method_payment">
                    <span class="app-modal-detail-list__label">Método de Pago</span>
                    <span class="app-modal-detail-list__value">
                      {{this.itemSelected.method_payment.name}}
                      <span v-if="parseFloat(itemSelected.method_payment.surcharge)>0">
                        ({{ parseFloat(itemSelected.method_payment.surcharge) }}%)
                      </span>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row">
                    <span class="app-modal-detail-list__label">Estado</span>
                    <span class="app-modal-detail-list__value">
                      <b-badge variant="primary" v-if="itemSelected.status=='open'">ABIERTO</b-badge>
                      <b-badge variant="success" v-if="itemSelected.status=='won'">GANADO</b-badge>
                      <b-badge variant="danger" v-if="itemSelected.status=='lost'">PERDIDO</b-badge>
                    </span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency">
                    <span class="app-modal-detail-list__label">Moneda</span>
                    <span class="app-modal-detail-list__value">{{itemSelected.currency.name}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency && itemSelected.amount_discount > 0">
                    <span class="app-modal-detail-list__label">Neto</span>
                    <span class="app-modal-detail-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(parseFloat(this.itemSelected.amount_net) + parseFloat(this.itemSelected.amount_discount))}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency && itemSelected.amount_discount > 0">
                    <span class="app-modal-detail-list__label">Descuento ({{itemSelected.percentage_discount}} %)</span>
                    <span class="app-modal-detail-list__value app-modal-detail-list__value--warning">({{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(this.itemSelected.amount_discount)}})</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency">
                    <span class="app-modal-detail-list__label">SubTotal</span>
                    <span class="app-modal-detail-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(this.itemSelected.amount_net)}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency">
                    <span class="app-modal-detail-list__label">IVA</span>
                    <span class="app-modal-detail-list__value">{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(this.itemSelected.amount_iva)}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.currency">
                    <span class="app-modal-detail-list__label">Total</span>
                    <span class="app-modal-detail-list__value"><b>{{Intl.NumberFormat('es-AR',{style:'currency',currency:this.itemSelected.currency.code}).format(this.itemSelected.amount_total)}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.recurrent">
                    <span class="app-modal-detail-list__label">Recurrente</span>
                    <span class="app-modal-detail-list__value"><b><i>Mensual</i></b></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.observations">
                    <span class="app-modal-detail-list__label">Observaciones</span>
                    <span class="app-modal-detail-list__value">{{this.itemSelected.observations}}</span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.observations_internal">
                    <span class="app-modal-detail-list__label">Observaciones Internas</span>
                    <span class="app-modal-detail-list__value"><div v-html="itemSelected.observations_internal"></div></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.title">
                    <span class="app-modal-detail-list__label">Titulo (Presupuesto)</span>
                    <span class="app-modal-detail-list__value"><div v-html="itemSelected.title"></div></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="itemSelected.sale && itemSelected.sale.type_voucher && itemSelected.sale.point_sale">
                    <span class="app-modal-detail-list__label">Factura</span>
                    <span class="app-modal-detail-list__value"><b>{{this.itemSelected.sale.type_voucher.name + ' ' + this.itemSelected.sale.point_sale.point_sale.toString().padStart(4,'0') + '-' + this.itemSelected.sale.number.toString().padStart(8,'0')}}</b></span>
                  </div>
                  <div class="app-modal-detail-list__row" v-if="!itemSelected.sale && this.itemSelected.sales_stage_related">
                    <span class="app-modal-detail-list__label">
                      <span v-if="isInvoiceStageProcess(itemSelected)">Facturas Parciales</span>
                      <span v-else>Facturado 100%</span>
                    </span>
                    <span class="app-modal-detail-list__value">
                      <div v-for="saleRel in this.itemSelected.sales_stage_related" :key="saleRel.id">
                        {{moment(saleRel.sale.date).format('D/M/Y')}} | {{saleRel.sale.type_voucher.name}} {{saleRel.sale.point_sale.point_sale.toString().padStart(4,'0')}}-{{saleRel.sale.number.toString().padStart(8,'0')}} | <b>{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(saleRel.amount_impute)}}</b>
                      </div>
                    </span>
                  </div>
                </div>
              </b-tab>
              <b-tab>
                <template #title><AppIcon name="list-ul" class="mr-1" /> Items</template>
                <b-table class="mb-0 app-table app-table--compact"
                        responsive
                        :stacked="isMobileViewport ? 'md' : false"
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="tableDetail.items"
                        :fields="tableDetail.fields"
                        v-if="tableDetail.items.length">

                  <template v-slot:table-colgroup="scope">
                    <col
                      v-for="field in scope.fields"
                      :key="field.key"
                      :style="{ width: field.width }"
                    >
                  </template>

                  <template v-slot:cell(product)="data">
                    <div class="crud-budgets-item-cell">
                      <div class="crud-budgets-item-cell__code" v-html="getDetailCode(data.item)"></div>
                      <div class="crud-budgets-item-cell__name" v-html="getDetailName(data.item)"></div>
                    </div>
                  </template>

                  <template v-slot:cell(list)="data">
                    <span v-if="data.item.price_list">
                      {{data.item.price_list.reference}}
                    </span>
                    <span v-else>
                      <span v-if="itemSelected.price_list">
                        {{itemSelected.price_list.reference}}
                      </span>
                    </span>
                  </template>

                  <template v-slot:cell(quantity)="data">
                    {{data.item.quantity}}
                    <span v-if="data.item.unit_measurement">{{data.item.unit_measurement.reference}}</span>
                  </template>

                  <template v-slot:cell(unit_price)="data">
                    <div v-if="itemSelected.currency">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.price_surcharge)}}
                    </div>
                  </template>

                  <template v-slot:cell(amount_net)="data">
                    <div v-if="itemSelected.currency">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_net)}}
                    </div>
                  </template>

                  <template v-slot:cell(subtotal)="data">
                    <div v-if="itemSelected.currency">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(parseFloat(data.item.quantity) * parseFloat(data.item.price_surcharge))}}
                    </div>
                  </template>

                  <template v-slot:cell(amount_iva)="data">
                    <div v-if="itemSelected.currency">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_iva)}}
                    </div>
                  </template>

                  <template v-slot:cell(amount_discount)="data">
                    <div v-if="itemSelected.currency" :class="{'text-danger':parseFloat(data.item.percentage_discount)>0}">
                      {{parseFloat(data.item.percentage_discount).toFixed(0)}}%
                      ({{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_discount)}})
                    </div>
                  </template>

                  <template v-slot:cell(amount_total)="data">
                    <div v-if="itemSelected.currency">
                      {{Intl.NumberFormat('es-AR',{style:'currency',currency:itemSelected.currency.code}).format(data.item.amount_total)}}
                    </div>
                  </template>
                </b-table>
                <EmptyState v-else icon="reports" title="No se encontraron registros" />
              </b-tab>
            </b-tabs>

          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.detail.active=false"><AppIcon name="x" class="mr-1" />Cerrar</b-button>
        </div>
      </b-modal>

      <!-- CRUD TEMPLATE -->
      <b-modal v-model="modal.template.active"
              no-close-on-esc
              no-close-on-backdrop
              hide-header-close
              size="xl"
              :key="modal.template._id"
              :id="modal.template._id">
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="reports" /></span>
          <h5 class="app-modal-header__title">{{this.modal.template.title}}</h5>
        </div>

        <b-row>
          <b-col lg="12">
            <div v-if="modal.template.budget && modal.template.budget.customer">
              <b>{{this.modal.template.budget.customer.name}}</b>
              <br>
              <div v-if="modal.template.budget.type_voucher && modal.template.budget.point_sale">
                {{modal.template.budget.type_voucher.name}} {{modal.template.budget.point_sale.point_sale.toString().padStart(4,'0') + '-' + modal.template.budget.number.toString().padStart(8,'0')}}
              </div>
            </div>
          </b-col>

          <b-col lg="12">
            <hr>
          </b-col>

          <b-col lg="12">
            <b-card no-body>
              <b-tabs pills card vertical class="budget-template">
                <b-tab v-for="item in modal.template.tabs"
                       :key="'dyn-tab-' + item.id"
                       :title="item.reference">
                  <b-row>
                    <b-col md="6">
                      <b-form-group label="Referencia">
                        <b-form-input type="text"
                                      size="sm"
                                      v-model="item.reference"
                                      required
                                      placeholder="Ingresar una referencia">
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col md="6">
                      <b-button size="sm" variant="danger" class="float-right" @click="closeTemplateTab(item)">
                        <AppIcon name="delete" /> Quitar
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <b-form-group label="Título">
                        <b-form-input type="text"
                                      size="sm"
                                      v-model="item.title"
                                      required
                                      placeholder="Ingresar un título">
                        </b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col md="12">
                      <b-form-group label="Observaciones">
                        <vue-editor class="display-template-ql-editor"
                                    v-model="item.description">
                        </vue-editor>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-tab>

                <template #tabs-end>
                  <b-nav-item role="presentation" @click.prevent="newTemplateTab" href="#" title="Agregar nuevo bloque">
                    <b>+</b>
                  </b-nav-item>
                </template>

                <template #empty>
                  <div class="text-center text-muted">
                    No hay bloques creados<br>
                    Crea uno nuevo desde el botón <b>+</b> de la barra de navegación.
                  </div>
                </template>
              </b-tabs>
            </b-card>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.template.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveTemplate()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

      <!-- CRUD GANADO O PERDIDO -->
      <b-modal v-model="modal.status.active"
              size="md"
              body-class="app-modal-form">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="flag" /></span>
          <h5 class="app-modal-header__title">{{this.modal.status.title}}</h5>
        </div>

        <div v-if="modal.status.budget" class="app-modal-detail-list mb-3">
          <div class="app-modal-detail-list__row" v-if="modal.status.budget.customer">
            <span class="app-modal-detail-list__label">Cliente</span>
            <span class="app-modal-detail-list__value"><b>{{ modal.status.budget.customer.name }}</b></span>
          </div>
          <div class="app-modal-detail-list__row" v-if="modal.status.budget.type_voucher && modal.status.budget.point_sale">
            <span class="app-modal-detail-list__label">Presupuesto</span>
            <span class="app-modal-detail-list__value">{{ modal.status.budget.type_voucher.name }} {{ modal.status.budget.point_sale.point_sale.toString().padStart(4,'0') + '-' + modal.status.budget.number.toString().padStart(8,'0') }}</span>
          </div>
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Estado del presupuesto" description="Seleccioná el estado que tendrá este presupuesto.">
              <b-button-group class="w-100">
                <b-button :variant="crud.formStatus.status == 'open' ? 'primary' : 'outline-primary'" @click="crud.formStatus.status='open'"><AppIcon name="flag" class="mr-1" />Abierto</b-button>
                <b-button :variant="crud.formStatus.status == 'won' ? 'success' : 'outline-success'" @click="crud.formStatus.status='won'"><AppIcon name="hand-thumbs-up" class="mr-1" />Ganado</b-button>
                <b-button :variant="crud.formStatus.status == 'lost' ? 'danger' : 'outline-danger'" @click="crud.formStatus.status='lost'"><AppIcon name="hand-thumbs-down" class="mr-1" />Perdido</b-button>
              </b-button-group>
            </b-form-group>
          </b-col>

          <b-col md="12" v-if="crud.formStatus.status == 'open'"><b-alert show variant="primary" class="mb-3"><AppIcon name="flag" class="mr-1" />El presupuesto se marcará como abierto.</b-alert></b-col>
          <b-col md="12" v-if="crud.formStatus.status == 'won'"><b-alert show variant="success" class="mb-3"><AppIcon name="hand-thumbs-up" class="mr-1" />El presupuesto se marcará como ganado.</b-alert></b-col>
          <b-col md="12" v-if="crud.formStatus.status == 'lost'"><b-alert show variant="danger" class="mb-3"><AppIcon name="hand-thumbs-down" class="mr-1" />El presupuesto se marcará como perdido.</b-alert></b-col>

          <b-col md="12" v-if="crud.formStatus.status == 'lost'">
            <b-form-group label="Observaciones internas" description="Estas observaciones no se muestran en la impresión">
              <app-textarea v-model="crud.formStatus.observations_internal" placeholder="Ingresar las observaciones internas..." rows="3" max-rows="4" lazy></app-textarea>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Fecha de estado">
              <b-form-datepicker size="sm" v-model="crud.formStatus.date_status" placeholder="Fecha" local="es"></b-form-datepicker>
            </b-form-group>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.status.active=false">Cancelar</b-button>
          <b-button variant="dark" :disabled="modal.status.budget && crud.formStatus.status == modal.status.budget.status" @click="saveStatus()"><AppIcon name="save" class="mr-1" />Guardar</b-button>
        </div>
      </b-modal>

      <!-- METODOS DE PAGO -->
      <b-modal v-model="modal.method_payment.active"
              no-close-on-backdrop
              hide-header-close
              size="lg">

        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="money" /></span>
          <h5 class="app-modal-header__title">{{this.modal.method_payment.title}}</h5>
        </div>

        <b-row>
          <b-col lg="12">
            <MethodPaymentSurcharge v-if="crud.form.price_list && crud.form.price_list.currency"
                                    :amount="totals.total"
                                    :currency="crud.form.price_list.currency.code"
                                    @setMethodPayment="setMethodPayment($event)"/>

            <MethodPaymentSurcharge v-else
                                    :amount="totals.total"
                                    currency="ARS"
                                    @setMethodPayment="setMethodPayment($event)"/>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.method_payment.active=false">Cancelar</b-button>
        </div>
      </b-modal>

      <!-- FACTURAR ETAPA -->
      <b-modal v-model="modal.invoiced_stage.active"
              no-close-on-backdrop
              hide-header-close
              size="md">

        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="ticket" /></span>
          <h5 class="app-modal-header__title">{{this.modal.invoiced_stage.title}}</h5>
        </div>

        <div class="budget-stage-invoice">
          <div class="budget-stage-invoice__intro"><AppIcon name="receipt_long" /><span>Definí el porcentaje del presupuesto aprobado que querés facturar ahora.</span></div>
          <div class="app-modal-detail-list">
            <div class="app-modal-detail-list__row">
              <span class="app-modal-detail-list__label">Presupuesto aprobado</span>
              <span class="app-modal-detail-list__value budget-stage-invoice__amount">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(crud.formInvoicedStage.amount_total)}}</span>
            </div>
            <div class="app-modal-detail-list__row">
              <span class="app-modal-detail-list__label">Ya facturado</span>
              <span class="app-modal-detail-list__value budget-stage-invoice__amount">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(crud.formInvoicedStage.amount_imputed)}}</span>
            </div>
            <div class="app-modal-detail-list__row budget-stage-invoice__row--input">
              <span class="app-modal-detail-list__label">A facturar</span>
              <span class="app-modal-detail-list__value"><span class="budget-stage-invoice__input"><b-input-group size="sm" append="%"><b-form-input v-model="crud.formInvoicedStage.percentage" type="number" min="0" max="100" step="1" @change="validIvoicePercentage()" /></b-input-group><strong class="budget-stage-invoice__amount">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(crud.formInvoicedStage.amount_impute)}}</strong></span></span>
            </div>
            <div class="app-modal-detail-list__row">
              <span class="app-modal-detail-list__label">Pendiente luego de facturar</span>
              <span class="app-modal-detail-list__value budget-stage-invoice__amount budget-stage-invoice__amount--pending">{{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyBudget}).format(parseFloat(crud.formInvoicedStage.amount_total) - (parseFloat(crud.formInvoicedStage.amount_imputed) + parseFloat(crud.formInvoicedStage.amount_impute)))}}</span>
            </div>
          </div>
        </div>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.invoiced_stage.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="actionGenerateInvoiceStage()"><AppIcon name="ticket" class="mr-1" />Facturar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import serviceSalesAPI from '@/components/modules/users/sales/staff/services'
  import Error from '@/handler/error'
  import ErrorToken from '@/handler/errorToken'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Funciones from '@/handler/funciones'
  import FindObject from '@/components/inc/find/findObject'
  import Printer from '@/components/inc/printer/printer'
  import Detail from '@/components/inc/cpbtDetail/detail'
  import moment from 'moment'
  import Param from '@/config/parameters'
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import { VueEditor } from "vue2-editor";
  import Storage from '@/handler/storageSession'
  import StorageLocal from '@/handler/storageLocal'
  import MethodPaymentSurcharge from './inc/methodPayment'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      Printer,
      Detail,
      FormWizard,
      TabContent,
      VueEditor,
      MethodPaymentSurcharge,
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PRESUPUESTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'budgets',
          elements: {
            deleteBudgets: true
          }
        },
        parameters: {
          multipleItems: Helper.hasParametersAccess(Param.P51),
          haveNotIva: Helper.hasParametersAccess(Param.P65),
        },
        configuracion: {
          allowMultipleBudgets: false,
        },
        selectedBudgets: [],
        appliedCustomers: [],
        table : {
          items: [],
          fields: [],
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,
        },
        tableSub : {
          items: [],
          fields: []
        },
        tableDetail : {
          items: [],
          fields: []
        },
        itemSelected: null,
        detailDrawer: false,
        filtersOpen: false,
        // Reactivo al viewport real (matchMedia), nunca un string fijo:
        // BootstrapVue apaga sticky-header si `stacked` está seteado a
        // cualquier valor truthy, incluso en desktop.
        isMobileViewport: false,
        crud: {
          form: {
            id: 0,
            date: '',
            date_expiration: '',
            types_vouchers_id: 10,
            types_vouchers: null,
            letter: '',
            number: 0,
            methods_payment_id: 0,
            methods_payment: null,
            price_list_id: 0,
            price_list: null,
            disable_customer_price_list_fallback: false,
            points_sales_id: 0,
            points_sales: null,
            observations: '',
            observations_internal: '',
            contact: '',
            contact_phone: '',
            contact_company: '',
            recurrent: false,
            title: 'Presupuesto',
            staff_id: 0,
            sellers_id: 0,
            customers_id: 0,
            customers: null,
            percentage_discount: 0,
            not_iva: false,
            detailProducts: [],
            detailProductsCompound: [],
            detailServices: [],
            detailConcepts: [],
          },
          print: {
            reference: 'budget',
            id: 0,
            key: 0,
          },
          formStatus: {
            id: 0,
            status: 'open',
            date_status: '',
            observations_internal: '',
          },
          formInvoicedStage: {
            id: 0,
            percentage: 0,
            amount_total: 0,
            amount_imputed: 0,
            amount_impute: 0,
          }
        },
        totals: {
          subtotal: 0,
          discount: 0,
          iva: 0,
          total: 0,
          total_surcharge: 0,
        },
        modal: {
          form: {
            active: false,
            title: '',
          },
          detail: {
            active: false,
            title: '',
          },
          template: {
            budget: null,
            tabs: [],
            tabCounter: 0,
            active: false,
            title: ''
          },
          status: {
            budget: null,
            active: false,
            title: '',
          },
          method_payment: {
            active: false,
            title: ''
          },
          invoiced_stage: {
            active: false,
            title: ''
          }
        },
        arr: {
          budgets: [],
          export: [],
          filters : {
            customers: [],
            sellers: [],
            points_sales: [],
            status: [
              {code: 'open', label: 'Abierto'},
              {code: 'won', label: 'Ganado'},
              {code: 'lost', label: 'Perdido'},
            ],
            invoiced: [
              {code: 'si', label: 'Facturado'},
              {code: 'parcial', label: 'Parcialmente Facturado'},
              {code: 'no', label: 'NO Facturado'}
            ],
            recurrent: [
              {code: true, label: 'Recurrente'},
              {code: false, label: 'No Recurrente'}
            ],
          },
        },
        filters: {
          date_start: '',
          date_end: '',
          customers: null,
          sellers: null,
          points_sales: null,
          invoiced: null,
          number: '',
          contact_search: '',
          status: [{code: 'open', label: 'Abierto'}],
          recurrent: null,
        },
        itemDetailForceUpdate: 0,
      }
    },
    created () {
        /* Configurar permisos de vistas y elementos */
        Helper.hasAccessView(this.access)
        this.access.elements.deleteBudgets = Helper.hasAccessElement(this.access, 'delete_budgets')
        /* Fin configuracion */

        window.addEventListener("keydown", this.handlerAccessDirect);
    },
    destroyed() {
      window.removeEventListener("keydown", this.handlerAccessDirect);
    },
    mounted() {
      this.filtersOpen = StorageLocal.getValue('filters_open_crud_budgets') == 'true'

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)

      this.loadSalesConfiguration()
      this.filterLoad()
      this.filterBudgets()

      // Acción directa desde la paleta de comandos: abrir el alta al entrar.
      if (this.$route.query.new == '1') {
        this.add()
        // Limpia el query apenas se consume -- si no, la pestaña queda con
        // ?new=1 pegado para siempre y volver a ella (activated, keep-alive)
        // reabriría el alta de nuevo aunque el usuario solo quiera ver el
        // listado.
        this.$router.replace({ path: this.$route.path, query: {} }).catch(() => {})
      }

      this._start = true
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    activated() {
      if(this._start) {
        this._start = false
        return false
      }

      this.selectedBudgets = []
      this.loadSalesConfiguration()
      this.filterLoad()
      this.filterBudgets()

      // Misma acción directa que en mounted(): si la pestaña ya estaba
      // montada (keep-alive), "mounted" no vuelve a correr y la paleta de
      // comandos no abriría nada sin este chequeo acá también.
      if (this.$route.query.new == '1') {
        this.add()
        this.$router.replace({ path: this.$route.path, query: {} }).catch(() => {})
      }
    },
    computed: {
      // NAVEGACION DEL DRAWER (anterior/siguiente sobre las filas cargadas)
      currentBudgetIndex() {
        if(!this.itemSelected || !this.table.items) {
          return -1
        }
        return this.table.items.findIndex(item => item.id === this.itemSelected.id)
      },
      canGoPrevBudget() {
        return this.currentBudgetIndex > 0
      },
      canGoNextBudget() {
        if(this.currentBudgetIndex < 0) {
          return false
        }
        return this.currentBudgetIndex < (this.table.items.length - 1)
      },

      // MODULES
      moduleSellersActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.VENDEDORES) {
            status = true
          }
        })
        return status
      },
      moduleSalesActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.VENTAS) {
            status = true
          }
        })
        return status
      },
      moduleServiceActive() {
        var status = false
        var modules = Session.getSession().auth.user.permissions.modules
        modules.forEach(element => {
          if(element.id == Modules.SERVICIOS) {
            status = true
          }
        })
        return status
      },

      // OTHERS
      subtotalItemSelected() {
        if(this.itemSelected) {
          return parseFloat(this.itemSelected.amount_total)
        } else {
          return 0
        }
      },

      // CONDITIONS SELECT
      conditionCustomersActive(){
        return [{field: 'active', condition: true}];
      },
      conditionPriceListActive(){
        return [{field: 'active', condition: true}];
      },
      conditionPointsSalesActive() {
        return [{field: 'active', condition: true}];
      },

      // CANT / CURRENCY
      getCantItemBudget() {
        var cant1 = this.crud.form.detailProducts.length
        var cant2 = this.crud.form.detailProductsCompound.length
        var cant3 = this.crud.form.detailServices.length
        var cant4 = this.crud.form.detailConcepts.length

        return parseFloat(cant1 + cant2 + cant3 + cant4)
      },
      getCurrencyBudget() {
        var currency = 'ARS'
        if(this.crud.form.price_list) {
          if(this.crud.form.price_list.currency) {
            currency = this.crud.form.price_list.currency.code
          }
        }
        return currency
      },

      // PRECIOS SIN IVA
      showCheckNotIva() {
        let status = false
        let codeAfipRI = 1 // Responsable Inscripto

        const haveNotIva = this.parameters.haveNotIva

        const pointsSales = this.crud.form.points_sales ? this.crud.form.points_sales : null
        const business = pointsSales ? pointsSales.business : null

        if(haveNotIva && business) {
          if(
            (business.fiscal_conditions_id == codeAfipRI && pointsSales.nd) ||
            (business.fiscal_conditions_id != codeAfipRI)
          ) {
            status = true
          }
        }

        return status;
      },

      // SELECCIÓN MÚLTIPLE
      canInvoiceSelected() {
        if(this.selectedBudgets.length < 1) return false
        const firstCustomer = this.selectedBudgets[0].customers_id
        return this.selectedBudgets.every(b => b.customers_id === firstCustomer)
      },
      eligibleBudgets() {
        return this.table.items.filter(item =>
          this.showGenerateInvoice(item) && this.showStatusWon(item) && !this.isInvoiceStageProcess(item)
        )
      },
      allEligibleSelected() {
        if(this.eligibleBudgets.length === 0) return false
        return this.eligibleBudgets.every(item => this.isBudgetSelected(item))
      },
    },
    watch: {
      filtersOpen: function (value) {
        StorageLocal.setValue('filters_open_crud_budgets', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.loadFieldTable()
      },
      'filters.customers': function () {
        this.selectedBudgets = []
      },
      'crud.form.customers_id': function (newQuestion, oldQuestion) {
        this.searchVoucher()
      },
      'crud.form.points_sales_id': function (newQuestion, oldQuestion) {
        this.searchVoucher()
      },
      'crud.form.price_list_id': function (newQuestion, oldQuestion) {
        if(newQuestion !== oldQuestion) {
          this.detailForceUpdate()
        }
      },
      'crud.form.disable_customer_price_list_fallback': function (newQuestion, oldQuestion) {
        if(newQuestion !== oldQuestion) {
          this.detailForceUpdate()
        }
      },
      'crud.form.detailProducts': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      },
      'crud.form.detailProductsCompound': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      },
      'crud.form.detailServices': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      },
      'crud.form.detailConcepts': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      },
      'crud.form.not_iva': function (newQuestion, oldQuestion) {
        this.searchTotalsTemporary()
      }
    },
    methods: {
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      avatarFromName(name) {
        return Funciones.avatarFromName(name)
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      // Click en la fila abre el drawer de detalle, salvo que el click haya
      // sido sobre un control (el dropdown de acciones, un link, etc.).
      onRowClicked(item, index, event) {
        if(!item) return

        if(event && event.target) {
          const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
          if(ignoreTags.includes(event.target.tagName)) return
          if(event.target.closest('.dropdown')) return
        }

        this.openSub(item)
      },
      // Resalta en la tabla la fila del registro que está abierto en el
      // drawer, para no perder la referencia visual mientras se navega con
      // los botones anterior/siguiente.
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(this.detailDrawer && this.itemSelected && item.id === this.itemSelected.id) {
          return 'app-table-row-active'
        }
        return ''
      },

      // CONFIGURACION VENTAS
      loadSalesConfiguration() {
        var result = serviceSalesAPI.obtenerConfiguracion()
        result.then((response) => {
          var data = response.data
          data.forEach(element => {
            if(element.id == 15) {
              this.configuracion.allowMultipleBudgets = element.value_boolean
            }
          })
          this.loadFieldTable()
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // SELECCIÓN MÚLTIPLE DE PRESUPUESTOS
      isBudgetSelected(item) {
        return this.selectedBudgets.some(b => b.id === item.id)
      },
      toggleBudgetSelection(item) {
        if(this.isBudgetSelected(item)) {
          this.selectedBudgets = this.selectedBudgets.filter(b => b.id !== item.id)
        } else {
          if(this.selectedBudgets.length > 0) {
            const firstCustomer = this.selectedBudgets[0].customers_id
            if(item.customers_id !== firstCustomer) {
              this.$awn.alert("Solo podés seleccionar presupuestos del mismo cliente")
              return
            }
          }
          this.selectedBudgets.push(item)
        }
      },
      toggleSelectAll() {
        if(this.allEligibleSelected) {
          // deseleccionar todos los elegibles visibles
          const eligibleIds = this.eligibleBudgets.map(b => b.id)
          this.selectedBudgets = this.selectedBudgets.filter(b => !eligibleIds.includes(b.id))
        } else {
          // seleccionar todos los elegibles visibles, validando mismo cliente
          const toAdd = this.eligibleBudgets.filter(item => !this.isBudgetSelected(item))
          for(const item of toAdd) {
            if(this.selectedBudgets.length > 0) {
              const firstCustomer = this.selectedBudgets[0].customers_id
              if(item.customers_id !== firstCustomer) continue
            }
            this.selectedBudgets.push(item)
          }
        }
      },
      generateInvoiceMultiple() {
        if(!this.canInvoiceSelected) return
        if(this.selectedBudgets.length === 1) {
          this.$router.push({ name: 'SalesStaffSalesGenerateByBudget', params: { budgetID: this.selectedBudgets[0].id } })
        } else {
          const ids = this.selectedBudgets.map(b => b.id).join(',')
          this.$router.push({
            name: 'SalesStaffSalesGenerateByMultipleBudgets',
            query: { budgetsIDs: ids }
          })
        }
      },

      // CONFIGURACION
      loadFieldTable () {
        // TABLE BUDGETS
        this.table.fields = []
        if(this.configuracion.allowMultipleBudgets) {
          this.table.fields.push({key: 'select_multi', label: '', class:"align-middle " + this.alignClass('text-center'), width:"30px"})
        }
        this.table.fields.push({key: 'business', label: 'Empresa', class:"align-middle " + this.alignClass('text-left'), width:"60px"})
        this.table.fields.push({key: 'id', label: 'Comprobante', class:"align-middle " + this.alignClass('text-center'), width:"170px"})
        this.table.fields.push({key: 'date', label: 'Fecha', class:"align-middle " + this.alignClass('text-center'), width:"80px"})
        this.table.fields.push({key: 'date_expiration', label: 'Vto', class:"align-middle " + this.alignClass('text-center'), width:"80px"})
        this.table.fields.push({key: 'customers_id', label: 'Cliente', class:"align-middle", width:"200px"})

        if(this.moduleSellersActive){
          this.table.fields.push({key: 'sellers_id', label: 'Vendedor', class:"align-middle " + this.alignClass('text-center'), width:"60px"})
        }

        this.table.fields.push({key: 'staff_id', label: 'Staff', class:"align-middle " + this.alignClass('text-center'), width:"60px"})
        this.table.fields.push({key: 'amount_total', label: 'Total', class:"align-middle " + this.alignClass('text-right'), width:"90px"})
        this.table.fields.push({key: 'observations', label: this.isMobileViewport ? 'Observaciones' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})
        this.table.fields.push({key: 'observations_internal', label: this.isMobileViewport ? 'Observaciones Internas' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})
        this.table.fields.push({key: 'invoice', label: this.isMobileViewport ? 'Facturación' : '', class:"align-middle " + this.alignClass('text-center'), width:"25px"})
        if(!this.isMobileViewport) {
          this.table.fields.push({key: 'f_action', label:'', class:"align-middle", width:"60px"})
        }

        // TABLE DETALLE (drawer)
        this.tableSub.fields = []
        this.tableSub.fields.push({key: 'quantity', label: 'Cantidad', class:"align-middle", width:"50px"})
        this.tableSub.fields.push({key: 'code', label: 'Código', class:"align-middle", width:"80px"})
        this.tableSub.fields.push({key: 'product', label: 'Item', class:"align-middle", width:"150px"})

        // TABLE DETALLE COMPLETO
        this.tableDetail.fields = []
        this.tableDetail.fields.push({key: 'product', label: 'Item', class:"align-middle " + this.alignClass('text-left'), width:"240px"})
        this.tableDetail.fields.push({key: 'list', label: 'Lista', class:"align-middle " + this.alignClass('text-left') + " text-truncate", width:"50px"})
        this.tableDetail.fields.push({key: 'quantity', label: 'Cant', class:"align-middle " + this.alignClass('text-right'), width:"60px"})
        this.tableDetail.fields.push({key: 'unit_price', label: 'P.Unit', class:"align-middle " + this.alignClass('text-right'), width:"70px"})
        this.tableDetail.fields.push({key: 'subtotal', label: 'Subtotal', class:"align-middle " + this.alignClass('text-right'), width:"70px"})
        this.tableDetail.fields.push({key: 'amount_discount', label: 'Desc', class:"align-middle " + this.alignClass('text-right'), width:"70px"})
        this.tableDetail.fields.push({key: 'amount_net', label: 'P.Neto', class:"align-middle " + this.alignClass('text-right'), width:"70px"})
        this.tableDetail.fields.push({key: 'amount_iva', label: 'IVA', class:"align-middle " + this.alignClass('text-right'), width:"70px"})
        this.tableDetail.fields.push({key: 'amount_total', label: 'Total', class:"align-middle " + this.alignClass('text-right'), width:"70px"})
      },
      getRowCount (items) {
        return items.length
      },

      // RENDER
      showGenerateInvoice(item) {
        var status = false
        if(!item.sale_id && !item.order_id && this.moduleSalesActive && !this.isInvoiceStageFinish(item)) {
          status = true
        }
        return status
      },
      isInvoiceStageProcess(item) {
        var status = false
        if(item.sales_stage_related) {
          const total = item.sales_stage_related.reduce((acum, rel) => {
              return acum + parseFloat(rel.amount_impute);
          }, 0);
          if(total > 0 && !this.isInvoiceStageFinish(item)) {
            status = true
          }
        }
        return status
      },
      isInvoiceStageFinish(item) {
        var status = false
        if(item.sales_stage_related) {
          const total = item.sales_stage_related.reduce((acum, rel) => {
              return acum + parseFloat(rel.amount_impute);
          }, 0);
          if(total >= parseFloat(item.amount_total)) {
            status = true
          }
        }
        return status
      },

      // SELECT
      loadCustomers (object) {
        if(object){
          this.crud.form.customers = object
          this.crud.form.customers_id = object.id

          if(object.data_fiscal) {
            if(object.data_fiscal.points_sales_id) {
              if(!this.crud.form.points_sales_id) {
                this.crud.form.points_sales = object.data_fiscal.points_sales
                this.crud.form.points_sales_id = object.data_fiscal.points_sales_id
              }
            }

            if(object.data_fiscal.methods_payment_id) {
              if(!this.crud.form.methods_payment_id) {
                this.crud.form.methods_payment = object.data_fiscal.methods_payment
                this.crud.form.methods_payment_id = object.data_fiscal.methods_payment_id

                let days = parseInt(object.data_fiscal.methods_payment.term)
                this.crud.form.date_expiration = moment(this.crud.form.date).add(days,'d').format('YYYY-MM-DD')
              }
            }
          }

          if(!this.crud.form.price_list_id) {
            if(!this.crud.form.disable_customer_price_list_fallback && object.price_list) {
              if(object.price_list.list) {
                this.crud.form.price_list = object.price_list.list
                this.crud.form.price_list_id = object.price_list.list.id
                this.crud.form.disable_customer_price_list_fallback = false
              }
            }
          }
        } else {
          this.crud.form.customers = null
          this.crud.form.customers_id = 0
          this.crud.form.disable_customer_price_list_fallback = false
        }
      },
      loadPointsSales (object) {
        if(object){
          this.crud.form.points_sales = object
          this.crud.form.points_sales_id = object.id

          // Resetear not_iva y solo cargarlo si el check debe mostrarse
          this.crud.form.not_iva = false
          // Los computed properties se evalúan síncronamente, no necesitamos $nextTick
          if(this.showCheckNotIva) {
            this.crud.form.not_iva = object.not_iva
          }
        } else {
          this.crud.form.points_sales = null
          this.crud.form.points_sales_id = 0
          this.crud.form.not_iva = false
        }
      },
      loadMethodsPayment (object) {
        if(object){
          this.crud.form.methods_payment = object
          this.crud.form.methods_payment_id = object.id
        } else {
          this.crud.form.methods_payment = null
          this.crud.form.methods_payment_id = 0
        }
      },
      loadPriceList (object) {
        if(object){
          this.crud.form.price_list = object
          this.crud.form.price_list_id = object.id
          this.crud.form.disable_customer_price_list_fallback = false
        } else {
          this.crud.form.price_list = null
          this.crud.form.price_list_id = 0
          this.crud.form.disable_customer_price_list_fallback = true
        }
      },
      prepareExport(data) {
        this.arr.export = []
        data.forEach(element => {
          var businessID = 0
          var businessName = ""
          var customersID = 0
          var customersCode = ""
          var customersName = ""
          var methodsPaymentID = 0
          var methodsPaymentName = ""
          var voucherReference = ""
          var currencyID = 0
          var currencyName = ""

          if(element.point_sale && element.point_sale.business) {
            businessID = element.point_sale.business.id
            businessName = element.point_sale.business.reference
          }
          if(element.customer) {
            customersID = element.customer.id
            customersCode = element.customer.code
            customersName = element.customer.name
          }
          if(element.method_payment) {
            methodsPaymentID = element.method_payment.id
            methodsPaymentName = element.method_payment.name
          }
          if(element.currency) {
            currencyID = element.currency.id
            currencyName = element.currency.name
          }
          if(element.type_voucher) {
            voucherReference = element.type_voucher.name + ' ' + element.point_sale.point_sale.toString().padStart(4,'0') + '-' + element.number.toString().padStart(8,'0')
          }

          this.arr.export.push({
            id: element.id,
            businessID: businessID,
            businessName: businessName,
            date: element.date,
            date_expiration: element.date_expiration,
            voucherReference: voucherReference,
            customersID: customersID,
            customersCode: customersCode,
            customersName: customersName,
            methodsPaymentID: methodsPaymentID,
            methodsPaymentName: methodsPaymentName,
            currencyID: currencyID,
            currencyName: currencyName,
            percentage: element.percentage_discount.replace('.',','),
            discount: element.amount_discount.replace('.',','),
            iva: element.amount_iva.replace('.',','),
            total: element.amount_total.replace('.',','),
            status: element.status,
            recurrent: element.recurrent,
            contact: element.contact,
            contact_phone: element.contact_phone,
            contact_company: element.contact_company,
            observations: element.observations,
            title: element.title,
            observations_internal: element.observations_internal,
            productID: 0,
            productCode: "",
            productName: "",
            serviceID: 0,
            serviceCode: "",
            serviceName: "",
            conceptID: 0,
            conceptName: "",
            productCompoundID: 0,
            productCompoundName: "",
            priceListID: 0,
            priceListName: "",
            quantity: 0,
            unitMeasurementID: 0,
            unitMeasurementName: "",
            unit_price: 0,
            surcharge: 0,
            unit_price_surcharge: 0,
            amount_net: 0,
            amount_discount: 0,
            amount_iva: 0,
            amount_total: 0,
          })

          element.details.forEach(element1 => {
            var productID = 0
            var productCode = ""
            var productName = ""
            var serviceID = 0
            var serviceCode = ""
            var serviceName = ""
            var conceptID = 0
            var conceptName = ""
            var productCompoundID = 0
            var productCompoundName = ""
            var unitMeasurementID = 0
            var unitMeasurementName = ""
            var priceListID = 0
            var priceListName = ""

            if(element1.products_id && element1.product) {
              productID = element1.product.id
              productCode = element1.product.code
              productName = element1.product.name
            }

            if(element1.products_colors_id && element1.products_color) {
              productID = element1.products_color.id
              productCode = element1.products_color.code
              productName = element1.products_color.name + " (" + element1.products_color.color.name + ")"
            }

            if(element1.products_waist_id && element1.products_waist) {
              productID = element1.products_waist.id
              productCode = element1.products_waist.code
              productName = element1.products_waist.name + " (" + element1.products_waist.waist.name + ")"
            }

            if(element1.products_color_waist_id && element1.products_color_waist) {
              productID = element1.products_color_waist.id
              productCode = element1.products_color_waist.code
              productName = element1.products_color_waist.name + " (" + element1.products_color_waist.color.name + " - " + element1.products_color_waist.waist.name + ")"
            }

            if(element1.services_id && element1.service) {
              serviceID = element1.service.id
              serviceCode = element1.service.code
              serviceName = element1.service.name
            }

            if(element1.concepts_id && element1.concept) {
              conceptID = element1.concept.id
              conceptName = element1.concept.name
            }

            if(element1.products_compound_id && element1.products_compound) {
              productCompoundID = element1.products_compound.id
              productCompoundName = element1.products_compound.name
            }

            if(element1.unit_measurement_id && element1.unit_measurement) {
              unitMeasurementID = element1.unit_measurement.id
              unitMeasurementName = element1.unit_measurement.name
            }

            if(element1.price_list_id && element1.price_list) {
              priceListID = element1.price_list.id
              priceListName = element1.price_list.name
            } else {
              if(element.price_list_id && element.price_list) {
                priceListID = element.price_list.id
                priceListName = element.price_list.name
              }
            }

            this.arr.export.push({
              productID: productID,
              productCode: productCode,
              productName: productName,
              serviceID: serviceID,
              serviceCode: serviceCode,
              serviceName: serviceName,
              conceptID: conceptID,
              conceptName: conceptName,
              productCompoundID: productCompoundID,
              productCompoundName: productCompoundName,
              priceListID: priceListID,
              priceListName: priceListName,
              quantity: element1.quantity.replace('.',','),
              unitMeasurementID: unitMeasurementID,
              unitMeasurementName: unitMeasurementName,
              unit_price: element1.price_unit.replace('.',','),
              surcharge: element1.surcharge ? element1.surcharge.replace('.',',') : '0',
              unit_price_surcharge: element1.price_surcharge.toString().replace('.',','),
              amount_net: element1.amount_net.replace('.',','),
              amount_discount: element1.amount_discount.replace('.',','),
              amount_iva: element1.amount_iva.replace('.',','),
              amount_total: element1.amount_total.replace('.',','),
            })
          })
        });
      },

      // ABM MAIN
      add() {
        this.crud.form.id = 0
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.date_expiration = moment().add(10,'d').format('YYYY-MM-DD')
        this.crud.form.observations = ''
        this.crud.form.observations_internal = ''
        this.crud.form.contact = ''
        this.crud.form.contact_phone = ''
        this.crud.form.contact_company = ''
        this.crud.form.recurrent = false
        this.crud.form.title = 'Presupuesto'
        this.crud.form.staff_id = Helper.getStaffId()
        this.crud.form.sellers_id = 0
        this.crud.form.customers_id = 0
        this.crud.form.customers = null
        this.crud.form.points_sales_id = 0
        this.crud.form.points_sales = null
        this.crud.form.methods_payment_id = 0
        this.crud.form.methods_payment = null
        this.crud.form.price_list_id = 0
        this.crud.form.price_list = null
        this.crud.form.disable_customer_price_list_fallback = false
        this.crud.form.percentage_discount = 0
        this.crud.form.detailProducts = []
        this.crud.form.detailProductsCompound = []
        this.crud.form.detailServices = []
        this.crud.form.detailConcepts = []

        setTimeout(()=>{
          if(this.$refs.input_contact) {
            this.$refs.input_contact.focus()
          }
        }, 1000)

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Presupuesto"
        this.modal.form.active = true
      },
      edit(item) {
        let loader = this.$loading.show();

        this.crud.form.id = item.id
        this.crud.form.date = moment(item.date).format('YYYY-MM-DD')
        this.crud.form.date_expiration = moment(item.date_expiration).format('YYYY-MM-DD')
        this.crud.form.observations = item.observations
        this.crud.form.observations_internal = item.observations_internal
        this.crud.form.contact = item.contact
        this.crud.form.contact_phone = item.contact_phone
        this.crud.form.contact_company = item.contact_company
        this.crud.form.recurrent = item.recurrent
        this.crud.form.title = item.title
        this.crud.form.staff_id = item.staff_id
        this.crud.form.sellers_id = item.sellers_id
        this.crud.form.customers_id = item.customers_id
        this.crud.form.customers = item.customer
        this.crud.form.points_sales_id = item.points_sales_id
        this.crud.form.points_sales = item.point_sale
        this.crud.form.methods_payment_id = item.methods_payment_id
        this.crud.form.methods_payment = item.methods_payment
        this.crud.form.price_list_id = item.price_list_id
        this.crud.form.price_list = item.price_list
        this.crud.form.disable_customer_price_list_fallback = !item.price_list_id
        this.crud.form.percentage_discount = item.percentage_discount
        this.crud.form.types_vouchers = item.type_voucher
        this.crud.form.types_vouchers_id = item.types_vouchers_id
        this.crud.form.letter = item.letter
        this.crud.form.number = item.number

        var result = serviceAPI.mostrarPresupuesto(item.id);

        result.then((response) => {
          var data = response.data.detail

          if(data) {
            this.crud.form.detailProducts = []
            this.crud.form.detailProductsCompound = []
            this.crud.form.detailServices = []
            this.crud.form.detailConcepts = []

            data.forEach(element => {
              if(element.product) {
                this.crud.form.detailProducts.push(element)
              }
              if(element.productCompound) {
                this.crud.form.detailProductsCompound.push(element)
              }
              if(element.service) {
                this.crud.form.detailServices.push(element)
              }
              if(element.concept) {
                this.crud.form.detailConcepts.push(element)
              }
            });
          }

          setTimeout(()=>{
            if(this.$refs.input_contact) {
              this.$refs.input_contact.focus()
            }
          }, 1000)

          this.modal.form._id = Math.random().toString(36).slice(2, 8)
          this.modal.form.title = "Editar Presupuesto"
          this.modal.form.active = true
          loader.hide()

          this.searchVoucher()
        })
      },
      remove(item) {
        this.crud.form.id = item.id

        var voucher = "ID #" + item.id
        if(item.type_voucher && item.point_sale) {
          voucher = item.type_voucher.name + ' ' + item.point_sale.point_sale.toString().padStart(4,'0') + '-' + item.number.toString().padStart(8,'0')
        }

        this.confirmDialog('¿Desea borrar el presupuesto ' + voucher + '?', {
          title: 'Borrar Presupuesto',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarPresupuesto(this.crud.form.id);

            result.then((response) => {
              this.modal.form.active = false
              if(this.itemSelected && this.itemSelected.id === this.crud.form.id) {
                this.hideSub()
              }
              loader.hide()
              this.filterBudgets()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        if(this.crud.form.contact_phone && !Funciones.validarTelefonoWhatsapp(this.crud.form.contact_phone)) {
          this.$awn.alert("El Teléfono no posee un formato válido para Whatsapp (cod país [sin el signo] + nueve [9] + cod área [sin el 0] + nro cel [sin el 15], total 13 dígitos)");
          return false
        }

        this.confirmDialog('¿Desea continuar con la generación del presupuesto?', {
          title: 'Generar Presupuesto',
          okTitle: 'GENERAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            if (this.crud.form.id) {
              var result = serviceAPI.editarPresupuesto(this.crud.form);
            } else {
              var result = serviceAPI.agregarPresupuesto(this.crud.form);
            }

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.filterBudgets(true)
              this.$awn.success("Presupuesto generado con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      cancel() {
        this.confirmDialog('¿Desea cancelar el presupuesto?', {
          title: 'Cancelar el Presupuesto',
          icon: 'warning',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            this.modal.form.active = false
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      setDetailItems(event, type) {
        if(type=="products") {
          this.crud.form.detailProducts = event
        }
        if(type=="productsCompound") {
          this.crud.form.detailProductsCompound = event
        }
        if(type=="services") {
          this.crud.form.detailServices = event
        }
        if(type=="concepts") {
          this.crud.form.detailConcepts = event
        }
      },
      budgetValidDetailGeneral() {
        this.searchTotalsTemporary()

        if(!this.crud.form.customers_id) {
          this.$awn.alert("No se cargó el cliente");
          return false;
        }
        if(!this.crud.form.points_sales_id) {
          this.$awn.alert("No se cargó el punto de venta");
          return false;
        }
        if(!this.crud.form.methods_payment_id) {
          this.$awn.alert("No se cargó el método de pago");
          return false;
        }

        if(Helper.hasParametersAccess(Param.P67)) {
          if(!this.crud.form.contact || this.crud.form.contact.trim() === '') {
            this.$awn.alert("Debe ingresar el nombre del contacto");
            return false;
          }
          if(!this.crud.form.contact_phone || this.crud.form.contact_phone.trim() === '') {
            this.$awn.alert("Debe ingresar el teléfono del contacto");
            return false;
          }
        }

        return true;
      },
      budgetValidDetailItems() {
          if( this.crud.form.detailProducts.length ||
              this.crud.form.detailProductsCompound.length ||
              this.crud.form.detailServices.length ||
              this.crud.form.detailConcepts.length) {
            return true;
          } else {
            this.$awn.alert("No se cargó ningún item");
            return false;
          }
      },

      // SELECT VOUCHER
      searchVoucher() {
        if(!this.crud.form.id) {
          if(this.crud.form.customers_id && this.crud.form.points_sales_id ) {
            var result = serviceAPI.obtenerVoucherById({
              'points_sales_id': this.crud.form.points_sales_id,
              'types_vouchers_id' : this.crud.form.types_vouchers_id,
            });
            result.then((response) => {
              this.crud.form.types_vouchers = response.data.type_voucher
              this.crud.form.letter = response.data.type_voucher.letter
              this.crud.form.number = response.data.number

              if( this.crud.form.types_vouchers ) {
                this.modal.form.title = this.crud.form.types_vouchers.name
                this.modal.form.title = this.modal.form.title + ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
                this.modal.form.title = this.modal.form.title + '-' + this.crud.form.number.toString().padStart(8,'0')
              }

            })
          }
        } else {
          if( this.crud.form.types_vouchers ) {
            this.modal.form.title = this.crud.form.types_vouchers.name
            this.modal.form.title = this.modal.form.title + ' ' + this.crud.form.points_sales.point_sale.toString().padStart(4,'0')
            this.modal.form.title = this.modal.form.title + '-' + this.crud.form.number.toString().padStart(8,'0')
          }
        }
      },
      searchTotalsTemporary() {
        if(this.crud.form.detailProducts || this.crud.form.detailProductsCompound || this.crud.form.detailsServices || this.crud.form.detailsConcepts) {
          var result = serviceAPI.obtenerVoucherTotalsTemporary({
            'header': this.crud.form,
            'detailsProducts': this.crud.form.detailProducts,
            'detailsProductsCompound': this.crud.form.detailProductsCompound,
            'detailsServices': this.crud.form.detailServices,
            'detailsConcepts': this.crud.form.detailConcepts,
            'methods_payment': this.crud.form.methods_payment,
          });
          result.then((response) => {
            var data = response.data

            this.totals.subtotal = data.amount_net
            this.totals.discount = data.amount_discount
            this.totals.subtotal_discount = data.amount_subtotal
            this.totals.iva = data.amount_iva
            this.totals.total = data.amount_total
            this.totals.total_surcharge = data.amount_total_surcharge
          })
        }
      },
      validDiscounts() {
        if(this.crud.form.percentage_discount=='') {
          this.crud.form.percentage_discount = 0
        } else {
          if( parseFloat(this.crud.form.percentage_discount) < 0 ||
              parseFloat(this.crud.form.percentage_discount) > 100 ) {
            this.crud.form.percentage_discount = 0
          }
        }
        this.searchTotalsTemporary()
      },

      // FILTER
      filterLoad() {
        this.filterLoadCustomers()
        this.filterLoadSellers()
        this.filterLoadPointSale()
        this.filters.date_start = moment().subtract(30, 'days').format('YYYY-MM-DD')
        this.filters.date_end = moment().format('YYYY-MM-DD')

        this.restoreFilterStorage()
      },
      detailForceUpdate() {
        this.itemDetailForceUpdate = this.itemDetailForceUpdate + 1
      },
      filterLoadCustomers() {
        var result = serviceAPI.obtenerClientes()
        result.then((response) => {
          var data = response.data

          this.arr.filters.customers = []
          data.forEach(element => {
            if(element.code) {
              this.arr.filters.customers.push({ code: element.id, label: element.code + ' | ' + element.name })
            } else {
              this.arr.filters.customers.push({ code: element.id, label: element.name })
            }
          });
        })
      },
      filterLoadSellers() {
        var result = serviceAPI.obtenerVendedores()
        result.then((response) => {
          var data = response.data

          this.arr.filters.sellers = []
          data.forEach(element => {
            this.arr.filters.sellers.push({ code: element.id, label: element.name })
          });
        })
      },
      filterLoadPointSale() {
        var result = serviceAPI.obtenerPuntosVentas()
        result.then((response) => {
          var data = response.data

          this.arr.filters.points_sales = []
          data.forEach(element => {
            this.arr.filters.points_sales.push({ code: element.id, label: element.full_identification })
          });
        })
      },
      filterBudgets(forceOpenSub=false) {
        this.saveFilterStorage()
        this.appliedCustomers = this.filters.customers ? [...this.filters.customers] : []

        this.table.isBusy = true
        var result = serviceAPI.filtrarPresupuesto(this.filters, this.table.currentPage)
        result.then((response) => {
          var data = response.data
          this.table.tablePaginate = data

          this.table.items = data.data
          this.arr.budgets = data.data
          this.prepareExport(data.data)

          this.table.items.forEach(element => {
            if(forceOpenSub && this.itemSelected && element.id == this.itemSelected.id) {
              this.openSub(element)
            }

            if(element.status == 'won') {
              element._rowVariant = 'success'
            } else if(element.status == 'lost') {
              element._rowVariant = 'danger'
            }
          });

          this.table.isBusy = false
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(ErrorToken.valid(error));
        })
      },

      // BUDGET DETAIL
      openSub(item) {
        this.itemSelected = item
        this.tableSub.items = item.details
        this.detailDrawer = true
      },
      hideSub() {
        this.tableSub.items=[]
        this.itemSelected = null
        this.detailDrawer = false
      },
      // Anterior/siguiente desde el drawer: reusa openSub() con el vecino,
      // así el contenido y el resaltado de fila se actualizan por el mismo
      // camino que un click directo en la tabla.
      goPrevBudget() {
        if(!this.canGoPrevBudget) return
        var item = this.table.items[this.currentBudgetIndex - 1]
        if(item) this.openSub(item)
      },
      goNextBudget() {
        if(!this.canGoNextBudget) return
        var item = this.table.items[this.currentBudgetIndex + 1]
        if(item) this.openSub(item)
      },
      openDetail() {
        this.tableDetail.items = this.itemSelected.details

        this.modal.detail._id = Math.random().toString(36).slice(2, 8)
        this.modal.detail.title = "Detalle del Presupuesto"
        this.modal.detail.active = true
      },
      getDetailCode(item) {
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          return this.getProductCode(item)
        }
        if(item.services_id) {
          return item.service.code
        }
        if(item.concepts_id) {
          return item.concept.code
        }
        if(item.products_compound_id) {
          return item.products_compound.code
        }
      },
      getDetailName(item) {
        if(item.products_id || item.products_colors_id || item.products_waist_id || item.products_color_waist_id) {
          return this.getProductName(item)
        }
        if(item.services_id) {
          return item.description
        }
        if(item.concepts_id) {
          return item.description
        }
        if(item.products_compound_id) {
          return item.description
        }
      },
      getProductCode(item) {
        var code = ''
        var prod = null

        if(item.code) {
          code = item.code
        }

        if(item.products_id) {
          if(code) {
            return code
          } else {
            return item.product.code
          }
        }

        if(item.products_colors_id) {
          prod = item.products_color
          if(code) {
            return code
          } else {
            return prod.code
          }
        }

        if(item.products_waist_id) {
          prod = item.products_waist
          if(code) {
            return code
          } else {
            return prod.code
          }
        }

        if(item.products_color_waist_id) {
          prod = item.products_color_waist
          if(code) {
            return code
          } else {
            return prod.code
          }
        }
      },
      getProductName(item) {
        var name = ''
        var prod = null

        if(item.description) {
          name = item.description
        }

        if(item.products_id) {
          if(name) {
            return name
          } else {
            return item.product.name
          }
        }

        if(item.products_colors_id) {
          prod = item.products_color
          if(name) {
            return name + ' (' + prod.color.name + ')'
          } else {
            return prod.name + ' (' + prod.color.name + ')'
          }
        }

        if(item.products_waist_id) {
          prod = item.products_waist
          if(name) {
            return name + ' (' + prod.waist.name + ')'
          } else {
            return prod.name + ' (' + prod.waist.name + ')'
          }
        }

        if(item.products_color_waist_id) {
          prod = item.products_color_waist
          if(name) {
            return name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
          } else {
            return prod.name + ' (' + prod.color.name + ' - ' + prod.waist.name + ')'
          }
        }
      },

      // PROCESS ADMINISTRATIVE
      generateInvoice(item) {
        this.$router.push({ name: 'SalesStaffSalesGenerateByBudget', params: {budgetID: item.id} })
      },

      // PROCESS ADMINISTRATIVE
      generateInvoiceStage(item) {
        this.modal.invoiced_stage.title = "Facturar por Etapas"
        this.modal.invoiced_stage.active = true

        this.crud.formInvoicedStage.id = item.id
        this.crud.formInvoicedStage.amount_total = item.amount_total
        this.crud.formInvoicedStage.amount_imputed = item.amount_impute
      },
      validIvoicePercentage() {
        if(this.crud.formInvoicedStage.percentage=='') {
          this.crud.formInvoicedStage.percentage = 0
        } else {
          if( parseFloat(this.crud.formInvoicedStage.percentage) < 0 ||
              parseFloat(this.crud.formInvoicedStage.percentage) > 100 ) {
            this.crud.formInvoicedStage.percentage = 0
          }
        }

        this.crud.formInvoicedStage.amount_impute = (parseFloat(this.crud.formInvoicedStage.amount_total) * parseFloat(this.crud.formInvoicedStage.percentage)) / 100
      },
      actionGenerateInvoiceStage() {
        let id = this.crud.formInvoicedStage.id
        let amount_impute = parseFloat(this.crud.formInvoicedStage.amount_impute)

        if(amount_impute <= 0 ) {
          this.$awn.alert("El importe a imputar debe ser mayor a cero");
        } else {
          this.$router.push({
            name: 'SalesStaffSalesGenerateByBudget',
            params: {
              budgetID: id,
            },
            query: {
              amount_impute: amount_impute,
            }
          })
        }
      },

      // PRINT
      sendPrinterBudget(item) {
        this.crud.print.key=Math.random()
        this.crud.print.id=item.id
      },

      // STATUS
      openStatus(item) {
        this.modal.status.budget = item

        this.crud.formStatus.id = item.id
        this.crud.formStatus.status = item.status
        this.crud.formStatus.date_status = moment().format('YYYY-MM-DD')
        this.crud.formStatus.observations_internal = item.observations_internal

        this.modal.status.active = true
        this.modal.status.title = "Cambiar Estado"
      },
      saveStatus() {
        let statusOld = this.modal.status.budget.status
        if(!this.crud.formStatus.status || this.crud.formStatus.status == statusOld) {
          this.$awn.info("Primero tenés que cambiar el estado del presupuesto para continuar");
          return false
        }

        this.confirmDialog('¿Cambiar el estado del presupuesto?', {
          title: 'Cambio de Estado',
          okTitle: 'CAMBIAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var result = serviceAPI.cambiarStatusPresupuesto(this.crud.formStatus);

            result.then((response) => {
              this.modal.status.active = false
              loader.hide()
              this.filterBudgets(true)
              this.$awn.success("Estado cambiado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      showStatusWon(item) {
        let status = false
        if(item.status == 'won') {
          status = true
        }
        return status
      },
      showStatusOpen(item) {
        let status = false
        if(item.status == 'open') {
          status = true
        }
        return status
      },
      showStatusLost(item) {
        let status = false
        if(item.status == 'lost') {
          status = true
        }
        return status
      },
      hasTemplateAvailable(item) {
        // Verifica si hay template en el presupuesto
        if(item.template && JSON.parse(item.template).length) {
          return true
        }

        // Verifica si hay al menos un detalle con servicio que tenga template_budget
        if(item.details && item.details.length) {
          return item.details.some(element =>
            element.service && element.service.template_budget
          )
        }

        return false
      },
      hasServiceDetail(item) {
        if(item.details && item.details.length) {
          return item.details.some(element => element.service || element.services_id)
        }
        return false
      },

      // PRESUPUESTO SERVICIO
      setTemplate(item){
        this.modal.template.budget = item

        this.modal.template.tabs = []
        this.modal.template.tabCounter = 0
        if(!item.template || !JSON.parse(item.template).length) {
          if(item.details) {
            item.details.forEach(element => {
              // Validación defensiva: verifica que service exista y tenga template_budget
              if(element.service && element.service.template_budget) {
                if(this.modal.template.tabCounter == 0) {
                  this.modal.template.tabs = JSON.parse(element.service.template_budget)
                  this.modal.template.tabCounter = this.modal.template.tabs.length
                } else {
                  let tabsTMP = JSON.parse(element.service.template_budget)
                  let tabCounterTMP = tabsTMP.length

                  tabsTMP.forEach(element => {
                    this.modal.template.tabs.push(element)
                  });

                  this.modal.template.tabCounter = this.modal.template.tabCounter + tabCounterTMP
                }
              }
            });
          }
        } else {
          this.modal.template.tabs = JSON.parse(item.template)
          this.modal.template.tabCounter = this.modal.template.tabs.length
        }

        this.modal.template._id = Math.random().toString(36).slice(2, 8)
        this.modal.template.active = true
        this.modal.template.title = "Plantilla"
      },
      newTemplateTab() {
        this.modal.template.tabs.push({
          id: this.modal.template.tabCounter++,
          reference: "Bloque " + this.modal.template.tabCounter,
          title: '',
          description: '',
        })
      },
      closeTemplateTab(item) {
        this.confirmDialog('¿Desea borrar el bloque ' + item.reference + '?', {
          title: 'Borrar Bloque',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            for (let i = 0; i < this.modal.template.tabs.length; i++) {
              if (this.modal.template.tabs[i].id === item.id) {
                this.modal.template.tabs.splice(i, 1)
              }
            }
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      saveTemplate() {
        this.confirmDialog('¿Guardar plantilla para este presupuesto?', {
          title: 'Plantilla',
          okTitle: 'GENERAR'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();

            var template = JSON.stringify(this.modal.template.tabs)

            var result = serviceAPI.editarTemplatePresupuesto({
              id: this.modal.template.budget.id,
              template: template,
            });

            result.then((response) => {
              this.modal.template.active = false
              loader.hide()
              this.filterBudgets()
              this.$awn.success("Plantilla guardada");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },

      // RECARGO METODO DE PAGO
      showSurchargeMethodPayment() {
        this.modal.method_payment.title = "Métodos de Pago Disponibles"
        this.modal.method_payment.active = true
      },
      setMethodPayment(object) {
        if(object){
          this.crud.form.methods_payment = object
          this.crud.form.methods_payment_id = object.id

          let days = parseInt(object.term)
          this.crud.form.date_expiration = moment(this.crud.form.date).add(days,'d').format('YYYY-MM-DD')
        }

        this.searchTotalsTemporary()
        this.modal.method_payment.active=false
      },

      // ACCESSOS DIRECTOS
      handlerAccessDirect(e) {

        // ctrl + shift + p = 80
        if (e.ctrlKey && e.shiftKey && e.keyCode === 80) {
          e.preventDefault();
          this.add()
        }

        // ctrl + shift + enter = 13
        if (e.ctrlKey && e.shiftKey && e.keyCode === 13) {
          e.preventDefault();

          if(this.$refs.wizard) {
            this.$refs.wizard.nextTab();
          }
        }

        // f2 = 113
        if(this.modal.form.active) {
          if (e.keyCode === 113) {
            if(this.$refs.searchCustomer) {
              this.$refs.searchCustomer.openSearch()
            }
          }
        }
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_crud_budget', JSON.stringify(this.filters))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_crud_budget')) {
          this.filters = JSON.parse(Storage.getValue('filter_crud_budget'))
        }
      },
    }
  }
</script>
<style>
  .budget-stage-invoice {
    display: grid;
    gap: 14px;
  }
  .budget-stage-invoice__intro {
    align-items: flex-start;
    background: var(--app-color-primary-soft);
    border: 1px solid var(--app-color-primary-border);
    border-radius: 8px;
    color: var(--app-color-text-secondary);
    display: flex;
    font-size: var(--app-text-sm);
    gap: 8px;
    line-height: 1.4;
    padding: 10px 12px;
  }
  .budget-stage-invoice__intro .app-icon {
    color: var(--app-color-primary);
    margin-top: 1px;
  }
  .budget-stage-invoice__amount {
    color: var(--app-color-text);
    font-weight: var(--app-font-semibold, 600);
  }
  .budget-stage-invoice__amount--pending {
    color: var(--app-color-primary-active);
  }
  .budget-stage-invoice__input {
    align-items: center;
    display: grid;
    gap: 10px;
    grid-template-columns: minmax(100px, 130px) minmax(0, 1fr);
  }
  .budget-stage-invoice__input .input-group {
    width: 100%;
  }
  .budget-stage-invoice__input strong {
    text-align: right;
  }
  @media (max-width: 575.98px) {
    .budget-stage-invoice__input {
      grid-template-columns: 1fr;
    }
    .budget-stage-invoice__input strong {
      text-align: left;
    }
  }
  .crud-budgets-wizard .wizard-header {
    padding: 0px;
  }
  .crud-budgets-wizard .wizard-card-footer {
    display: flex !important;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 4px 0;
  }
  .crud-budgets-wizard .wizard-card-footer .wizard-footer-left,
  .crud-budgets-wizard .wizard-card-footer .wizard-footer-right {
    float: none !important;
  }
  .crud-budgets-wizard .wizard-card-footer .wizard-footer-right {
    margin-left: auto;
  }
  .crud-budgets-wizard .wizard-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 112px;
    height: 36px;
    padding: 6px 14px;
    border-width: 1px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: var(--app-font-semibold);
    box-shadow: none;
    transition: background-color .15s ease, border-color .15s ease, color .15s ease;
  }
  .crud-budgets-wizard .wizard-footer-left .wizard-btn::before,
  .crud-budgets-wizard .wizard-footer-right .wizard-btn::after {
    font-family: 'Material Symbols Rounded';
    font-size: 18px;
    font-weight: normal;
    font-style: normal;
    font-feature-settings: 'liga';
    line-height: 1;
  }
  .crud-budgets-wizard .wizard-footer-left .wizard-btn::before {
    content: 'arrow_back';
    margin-right: 6px;
  }
  .crud-budgets-wizard .wizard-footer-right .wizard-btn::after {
    content: 'arrow_forward';
    margin-left: 6px;
  }
  .crud-budgets-wizard .wizard-footer-left .wizard-btn {
    background-color: var(--app-color-surface) !important;
    border-color: var(--app-color-border-strong) !important;
    color: var(--app-color-text-secondary) !important;
  }
  .crud-budgets-wizard .wizard-footer-left .wizard-btn:hover {
    background-color: var(--app-color-surface-subtle) !important;
    color: var(--app-color-text) !important;
  }
  .crud-budgets-wizard .wizard-footer-right .wizard-btn {
    background-color: var(--app-color-primary) !important;
    border-color: var(--app-color-primary) !important;
    color: #fff !important;
  }
  .crud-budgets-wizard .wizard-footer-right .wizard-btn:hover {
    filter: brightness(.94);
  }
  @media (max-width: 767.98px) {
    .crud-budgets-wizard .wizard-card-footer {
      gap: 8px;
      padding: 12px 0 0;
    }
    .crud-budgets-wizard .wizard-footer-left,
    .crud-budgets-wizard .wizard-footer-right {
      display: flex;
      flex: 1 1 0;
    }
    .crud-budgets-wizard .wizard-card-footer .wizard-footer-right {
      margin-left: 0;
    }
    .crud-budgets-wizard .wizard-footer-left > span,
    .crud-budgets-wizard .wizard-footer-right > span {
      display: block;
      width: 100%;
    }
    .crud-budgets-wizard .wizard-btn {
      width: 100%;
      min-width: 0;
    }
  }
  .crud-budgets-stat {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 8px;
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
  }
  .crud-budgets-stat__label {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .crud-budgets-stat__value {
    font-size: 22px;
    font-weight: var(--app-font-semibold);
    color: var(--app-color-text);
  }
  .crud-budgets-totals {
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
    padding: 10px 12px;
  }
  .crud-budgets-totals__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 0;
    font-size: 12px;
  }
  .crud-budgets-totals__row + .crud-budgets-totals__row {
    border-top: 1px dashed var(--app-color-border);
  }
  .crud-budgets-totals__label {
    color: var(--app-color-text-muted);
    font-weight: var(--app-font-semibold);
    text-transform: uppercase;
    font-size: 11px;
    letter-spacing: 0.02em;
    flex: 1 1 auto;
    min-width: 0;
  }
  .crud-budgets-totals__value {
    font-weight: var(--app-font-semibold);
    text-align: right;
    white-space: nowrap;
    flex: 0 0 auto;
  }
  .crud-budgets-totals__row--total {
    border-top: 2px solid var(--app-color-primary) !important;
    margin-top: 4px;
    padding-top: 8px;
  }
  .crud-budgets-totals__row--total .crud-budgets-totals__label,
  .crud-budgets-totals__row--total .crud-budgets-totals__value {
    font-size: 14px;
    color: var(--app-color-text);
  }
  .crud-budgets-totals__discount-group {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
  }
  .crud-budgets-totals__discount {
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .crud-budgets-totals__discount input {
    width: 62px;
    height: 26px;
    padding: 2px 4px;
    text-align: right;
  }
  .crud-budgets-totals__discount-suffix {
    color: var(--app-color-text-muted);
    font-size: 12px;
  }
  .budgets-form-modal-dialog {
    max-width: min(1400px, calc(100vw - 24px));
  }
  .crud-budgets-item-cell {
    padding: 6px 0;
  }
  .crud-budgets-item-cell__code {
    color: var(--app-color-text-muted);
    font-size: var(--app-text-xs);
    margin-bottom: 2px;
  }
  .crud-budgets-item-cell__name {
    line-height: 1.35;
  }
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;
  }
</style>
<style>
  .display-template-ql-editor .ql-editor {
    min-height: 350px !important;
  }
  .budget-template .nav-link:hover {
    text-decoration: underline;
  }
</style>
